import ContentLoader from 'react-content-loader';
import styled from 'styled-components';
export const TimerLoaderWrapper = styled.div ``;
export const TimerLoaderContent = styled(ContentLoader) `
  width: 11.3rem;
  height: 2.8rem;
`;
export const Text = styled.rect `
  height: 2.8rem;
  width: 100%;

  rx: ${({ theme }) => theme.borderRadius.high};
  ry: ${({ theme }) => theme.borderRadius.high};
`;
//# sourceMappingURL=styles.js.map